export default __webpack_public_path__ + "static/media/exchangelogo.9d79a73b.svg";